import type { AiTextKind } from '@pulsify/shared/dto'
import { useMutation } from '@tanstack/react-query'
import { textApi } from '../api'

interface GenerateTextVars {
  kind: AiTextKind
  prompt: string
}

export function useGenerateText(businessId: string) {
  return useMutation({
    mutationFn: ({ kind, prompt }: GenerateTextVars) => textApi.generate(businessId, kind, prompt),
  })
}
